export default "__VITE_ASSET__Cy19F511__"